
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liveband",
      function () {
        return require("private-next-pages/liveband/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liveband"])
      });
    }
  